<div class="app-container">
    <app-header></app-header>
    <div class="app-flex-container">
        <div class="app-content">
            <router-outlet></router-outlet>
        </div>
        <app-footer class="app-footer"></app-footer>
    </div>
</div>